import React from "react";
import { Box, Button } from "@mui/material";
import LockLeftIcon from "@mui/icons-material/KeyboardDoubleArrowLeft";
import ChevronUpIcon from "@mui/icons-material/KeyboardArrowUp";

// The Hide Navigation / Lock-to-left controls that sit above the search box in
// the Dashboard launchpad. Rendered bare (no glass container) per the nav
// layout: only the search box and the individual nav items are boxed.
//
// "Hide Navigation" only makes sense once a bookmark exists to fall back to, so
// it is omitted until then; the empty spacer keeps "Lock" pinned to the right
// in that case. On mobile with no bookmarks there is nothing to show at all.
export default function DashboardNavControls({
  isMobile,
  hasBookmarks,
  sidebarLocked,
  onHide,
  onLock,
}) {
  if (!hasBookmarks && isMobile) return null;

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        // Mobile shows only "Hide Navigation" (no Lock control), so center it
        // instead of leaving it pinned left by the desktop space-between layout.
        justifyContent: isMobile ? "center" : "space-between",
      }}
    >
      {hasBookmarks ? (
        <Button
          startIcon={<ChevronUpIcon />}
          aria-label="Hide navigation"
          onClick={onHide}
        >
          Hide Navigation
        </Button>
      ) : (
        <Box />
      )}
      {!isMobile && (
        <Button
          startIcon={<LockLeftIcon />}
          disabled={sidebarLocked}
          aria-label="Lock navigation to left screen"
          onClick={onLock}
        >
          {sidebarLocked ? "Locked to left screen" : "Lock to left screen"}
        </Button>
      )}
    </Box>
  );
}
